import  gql  from 'graphql-tag'

export const users = gql`query Users($name: String, $group: Float, $agency: Float, $analystType: Float, $regional: Float){
    users(name: $name, group: $group, agency: $agency, analystType: $analystType, regional: $regional){
        edges{
            node{
            id
            username
            name
            surname
            email
            authSystem
            isActive
            group{
                id
                name
                permissions{
                    edges{
                        node{
                            id
                            name
                            codename
                        }
                    }
                }
            }
            creditanalyst{
                id
                office{
                    id
                    name
                    regional{
                        id
                        name
                    }
                }
                analystType{
                    id
                    name
                }
            }
            officedirector{
                id
                office{
                    id
                    name
                    regional{
                        id
                        name
                    }
                }
            }
            regionaldirector{
                id
                regional{
                    id
                    name
                }
            }
            }
        }
        }
    }`;
